import axios from 'axios';
import _, { startCase } from 'lodash'
import {useSkip, usePagination} from '../../helpers/pagination';
// initial state
// shape: [{ id, quantity }]
const state = () => ({
    list : [],
    loaded : false,
    addNew : false,
    columns : [
      {
        table: "users",
        direction : "ASC",
        direction_pos : 0,
        key : "name",
        label : "Name",
        display : true
    },
    {
        table: "users",
        direction : "ASC",
        direction_pos : 0,
        key:"email",
        label: "E-Mail",
        display : true,
    },
    {
        table: "users",
        direction : "ASC",
        direction_pos : 0,
        key:"letter",
        label: "Letter",
        display : true,
    },
    {
        table: "users",
        key:"is_tracking",
        label: "is_tracking",
        display : true,
        type: "boolean",
    }
    ],
    internalCompanies: [],
    workingOn: [],
    isSavingNew : false,
    infinity : {
        clear: false,
        search : "",
        columns : ['name', 'email', "letter"],
        allLoaded : false,
        loading : false,
        loadingMore : false,
        take : 20,
        active: true,
        filters: []
    },
    skip : 0,
    take : 20,
    pagination: {
        currentPage: 1,
        totalPageCount: 1,
    },
    meta: {},
})

  // getters
  const getters = {
      id : (state) => (id) => {
        return state.list[state.list.findIndex(item => item.id == id)]
      }
  }

  // actions
  const actions = {

    async load({commit, state, rootState}, page = 1){
        if(state.infinity.loading == false){
            commit("infinityLoading", true);
            if(state.infinity.clear == true){
                var skip = 0;
            }else{
                if(state.infinity.active == true){
                    commit("skip", state.list.length);
                }else{
                    commit("skip", (page - 1) * state.take);
                }
            }
            console.log("load users");
            return await axios.get(rootState.settings.url + "/api/v1/"+rootState.settings.internal.user_company +"/users", {params : {search : state.infinity.search, take: state.take, skip : state.skip, columns : state.infinity.columns, table_columns : state.columns, infinityFilters: state.infinity.filters}}).then((response) => {
                console.log("load users response");
                commit("set", response.data.data);
                commit("pagination", _.get(response, "data.meta.pagination", { total: 0, take: state.take }))
                commit("setInternalCompanies", _.get(response, "data.meta.internalCompanies", []))
                commit("loaded", true);
                commit("infinityLoading", false);
            });
        }
    },
        async minimal_load({commit, state, rootState}, page = 1){
        if(state.infinity.loading == false){
            commit("infinityLoading", true);
            if(state.infinity.clear == true){
                var skip = 0;
            }else{
                if(state.infinity.active == true){
                    commit("skip", state.list.length);
                }else{
                    commit("skip", (page - 1) * state.take);
                }
            }
            return await axios.get(rootState.settings.url + "/api/v1/"+rootState.settings.internal.user_company +"/minimal_users", {params : {search : state.infinity.search, take: state.take, skip : state.skip, columns : state.infinity.columns, table_columns : state.columns, infinityFilters: state.infinity.filters}}).then((response) => {
                commit("set", response.data.data);
                commit("pagination", _.get(response, "data.meta.pagination", { total: 0, take: state.take }))
                commit("setInternalCompanies", _.get(response, "data.meta.internalCompanies", []))
                commit("loaded", true);
                commit("infinityLoading", false);
            });
        }
    },

    async update({ commit, rootState }, data) {
        await axios.put(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/users/" + data.id, data).then(response => {
            commit("update", response.data.data);
        })
    },
    async store({ commit, rootState }, data) {
        await axios.post(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/users", data).then(response => {
            commit("unshift", response.data.data);
        })
    },
    async delete({commit, rootState}, data){
        await axios.delete(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/users/" + data.id).then(response => {
            commit("removeId", response.data.deleted);
        })
    },
    async get({commit, rootState}, data) {
        return await axios.get(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/users/" + data.id)
        .then(response => {
            commit("setInitial", response.data.data)
        });
    }
  }

  // mutations
  const mutations = {
    setInternalCompanies(state, data){
        state.internalCompanies = data;
    },
    skip(state, skip){
        state.skip = skip;
    },
    pagination(state, object) {
        state.meta = object;
        if (state.skip <= 0) {
            state.pagination.currentPage = 1;
        } else {
            state.pagination.currentPage = (state.skip / state.take) + 1;
        }
        state.pagination.totalPageCount = Math.ceil(state.meta.total / state.take);
        state.pagination.total = state.meta.total
        state.pagination.pagesize = state.take

        if(state.infinity.active == true && state.meta.total <= state.skip){
            state.allLoaded = true;
        }
    },
    removeId(state, id){
        var index = state.list.findIndex(item => item.id == id);
        if(index >= 0){
            state.list.splice(index, 1);
        }
    },
      clean(state){
        state.list = [];
        state.infinity.allLoaded = false;
        state.loaded = false;
        state.workingOn = [];
        state.infinity.filters = {};
        state.infinity.loading = false
      },
      update(state, element) {
        var index = state.list.findIndex(item => item.id == element.id);
        state.list[index] = element;
    },
        addCompany(state, load){
            state.addNew = load;
        },
        store(state, company){
            state.list.unshift(company);
        },
        unshift(state, element){
            state.list.unshift(element);
        },
      set(state, data){
          if(state.infinity.clear == true){
              state.data = [];
              state.allLoaded = false;
              state.infinity.clear = false;
          }
          if(data == undefined || data.length < state.take){
              state.infinity.allLoaded = true;
          }
          if(state.infinity.active == true){
              state.list.push(...data);
            }else{
                state.list = data;
            }
      },
      loaded(state, status){
          state.loaded = status;
      },
      isSavingNew(state, status){
          state.isSavingNew = status;
      },
        setSearch(state, search){
            state.infinity.allLoaded = false;
            state.infinity.search = search;
            state.infinity.clear = true;
        },
        infinityLoading(state, status){
            state.infinity.loading = status;
        },
        setSearchValue(state, value){
            state.infinity.search = value;
        },
        infinityActive(state, status){
            state.infinity.active = status;
        },
        updateColumn(state, column){
            var index = state.columns.findIndex(item => item.key == column.key)
            for(let i in state.columns){
                state.columns[i].direction_pos += 1;
            }
            if(index > -1){
                column.direction_pos = 0;
                state.columns[index] = column;
            }
        },
        setInitial(state, element){
            if(element && element.id != 0 && element.name != undefined) {
                var index = state.list.findIndex(item => item.id == element.id)
                if(index < 0) {
                    state.list.push(element);
                }
            }
        },
        setInfinityFilter(state, element) {
            state.infinity.loading = false;
            state.infinity.filters = element;
        },
        clearInfinityFilter(state) {
            state.infinity.filters = {};
            state.infinity.loading = false
        }
  }

  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
    }
  }
